module.exports = __webpack_public_path__ + "img/u512.d5e8f8c7.svg";